// src/lib/cn.ts — class-name utility (clsx + tailwind-merge).
// Plan ref: 05-RESEARCH-ui-shell.md §Anti-Patterns ("don't reinvent cn").

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
